module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.buttonStyle ? 'label' : 'div', {
    tag: "div",
    class: [(_vm.buttonStyle ? 'btn btn-' + _vm.typeColor : 'radio ' + _vm.typeColor), {
      active: _vm.active,
      disabled: _vm.disabled,
      readonly: _vm.readonly
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [(_vm.buttonStyle) ? [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.check),
      expression: "check"
    }],
    ref: "input",
    attrs: {
      "type": "radio",
      "autocomplete": "off",
      "name": _vm.name,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.checkedValue,
      "checked": _vm._q(_vm.check, _vm.checkedValue)
    },
    on: {
      "change": function($event) {
        _vm.check = _vm.checkedValue
      }
    }
  }), _vm._v(" "), _vm._t("default")] : _c('label', {
    staticClass: "open"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.check),
      expression: "check"
    }],
    ref: "input",
    attrs: {
      "type": "radio",
      "autocomplete": "off",
      "name": _vm.name,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.checkedValue,
      "checked": _vm._q(_vm.check, _vm.checkedValue)
    },
    on: {
      "change": function($event) {
        _vm.check = _vm.checkedValue
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon dropdown-toggle",
    class: [_vm.active ? 'btn-' + _vm.typeColor : '', {
      bg: _vm.typeColor === 'default'
    }]
  }), _vm._v(" "), (_vm.active && _vm.typeColor === 'default') ? _c('span', {
    staticClass: "icon"
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f5937b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vuestrap/Radio.vue
// module id = 529
// module chunks = 2